import { Component, Input, OnInit } from '@angular/core';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { IntegrationsService } from "@app/modules/site-settings-integrations/services/integrations.service";
import { PayzaarIntegrationDetails } from '@app/modules/site-settings-integrations/models/integrations.model';

@Component({
  selector: 'app-payzaar-details-tab',
  templateUrl: './payzaar-details-tab.component.html',
  styleUrls: ['./payzaar-details-tab.component.scss']
})
export class PayzaarDetailsTabComponent implements OnInit {
    @Input() integrationId: string;
    public integrationConfig: PayzaarIntegrationDetails = null;

    // FORM
    formId: string = 'frm_NKcztePS1uuph5';
    formData: any;
    getFormData: boolean = false;
    formValid: boolean = false;
    formPristine: boolean = true;
    formLoaded: boolean = false;

    constructor(
        private translate: TranslateService,
        private snackbarService: SnackbarService,
        private overlayService: OverlayService,
        private integrationService: IntegrationsService,
    ) {
    }

    ngOnInit(): void {
        this.getData();
    }

    formDataEmitted(formDataEmitted) {
        this.save(formDataEmitted);
    }

    formStatusUpdated(formValid) {
        if (!this.formLoaded) {
            this.formLoaded = true;
        }

        this.formValid = formValid;
    }

    formPristineEmitted(formPristine: boolean) {
        this.formPristine = formPristine;
    }

    getData() {
        this.integrationService.getPayzaarIntegrationConfig(this.integrationId).subscribe(res => {
            this.integrationConfig = res;

            this.buildFormData();
        })
    }

    buildFormData() {
        this.formData = {
            storageAccountName: this.integrationConfig.azureStorage ? this.integrationConfig.azureStorage.storageAccountName : null,
            containerName: this.integrationConfig.azureStorage ? this.integrationConfig.azureStorage.containerName : null,
            sasToken: this.integrationConfig.azureStorage ? this.integrationConfig.azureStorage.sasToken : null,
            dayOfMonth: this.integrationConfig.schedule ? this.integrationConfig.schedule.dayOfMonth : null,
            hour: this.integrationConfig.schedule ? this.integrationConfig.schedule.hour : null,
            minute: this.integrationConfig.schedule ? this.integrationConfig.schedule.minute : null,
            timezoneId: this.integrationConfig.schedule ? this.integrationConfig.schedule.timezone?.id : null,
            cultureId: this.integrationConfig.culture ? this.integrationConfig.culture?.id : null,
            employeeFilter: this.integrationConfig.employeeFilter
        }
    }

    save(formDataEmitted) {
        this.overlayService.show();

        formDataEmitted = {
            azureStorage: {
                storageAccountName: formDataEmitted.storageAccountName,
                containerName: formDataEmitted.containerName,
                sasToken: formDataEmitted.sasToken
            },
            schedule: {
                dayOfMonth: formDataEmitted.dayOfMonth,
                hour: formDataEmitted.hour,
                minute: formDataEmitted.minute,
                timezoneId: formDataEmitted.timezoneId
            },
            cultureId: formDataEmitted.cultureId,
            employeeFilter: formDataEmitted.employeeFilter
        }

        this.integrationService.updatePayzaarIntegrationConfig(this.integrationId, formDataEmitted)
        .subscribe(
            {
                next: (v) => {
                    this.snackbarService.openSnackBar(this.translate.instant('IntegrationConfigUpdated'), 'clear', 'success');
                },
                complete: () => this.overlayService.hide()
            }
        );
    }
}
